import permissions from 'src/js/modules/extensions/registry/ws-image/constants/permissions';
import showClipboardAccessDeniedDialog from 'src/js/modules/extensions/registry/ws-image/helpers/show-clipboard-access-denied-dialog';
import showUnsupportedBrowserDialog from 'src/js/modules/extensions/registry/ws-image/helpers/show-unsupported-browser-dialog';

const handleClipboardPermissionDeniedReason = (reason) => {
  switch (reason) {
    case permissions.permissionDeniedReasons.UNSUPPORTED_BROWSER:
      showUnsupportedBrowserDialog();
      break;
    case permissions.permissionDeniedReasons.ACCESS_DENIED:
      showClipboardAccessDeniedDialog();
      break;
    default:
  }
};

export default handleClipboardPermissionDeniedReason;
